<script setup lang="ts"></script>

<template>
  <div class="ui-tabs">
    <div class="ui-tabs__nav-wrapper">
      <div class="ui-tabs__btn ui-tabs__btn-up">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.04176 10.2762L11.4054 16.9429C11.7327 17.2858 12.2674 17.2858 12.5947 16.9429L18.9583 10.2762C19.2806 9.93858 19.2806 9.39485 18.9583 9.05722C18.631 8.71433 18.0963 8.71433 17.769 9.05722L12 15.1009L6.23106 9.05722C5.90376 8.71433 5.36907 8.71433 5.04176 9.05722C4.71948 9.39485 4.71948 9.93858 5.04176 10.2762Z"
          />
        </svg>
      </div>
      <div class="ui-tabs__nav-shadow">
        <ul ref="navListRef" class="ui-tabs__nav">
          <li
            v-for="tab in Array(10)"
            :key="tab"
            class="btn-text"
            :class="['ui-tabs__tab']"
          >
            {{ tab }}
          </li>
        </ul>
      </div>
      <div class="ui-tabs__btn">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.04176 10.2762L11.4054 16.9429C11.7327 17.2858 12.2674 17.2858 12.5947 16.9429L18.9583 10.2762C19.2806 9.93858 19.2806 9.39485 18.9583 9.05722C18.631 8.71433 18.0963 8.71433 17.769 9.05722L12 15.1009L6.23106 9.05722C5.90376 8.71433 5.36907 8.71433 5.04176 9.05722C4.71948 9.39485 4.71948 9.93858 5.04176 10.2762Z"
          />
        </svg>
      </div>
    </div>
    <div class="ui-tabs__panel">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
.ui-tabs {
  display: flex;
  flex-direction: row;
  gap: 24px;

  &__btn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    transition: all 0.2s ease-in-out;
    border-radius: 8px;
    background: linear-gradient(
      107deg,
      #f6f8fd 36.98%,
      #e1e5f0 49.48%,
      #f6f8fd 61.46%
    );
    animation: 3s shine linear infinite;
    background-size: 200% 100%;

    svg {
      fill: #839aaf;
    }

    &.lock {
      background: #f4f6fd;
      cursor: default;

      svg {
        fill: #e1e5f0;
      }
    }

    &-up {
      svg {
        transform: scale(1, -1);
      }
    }
  }

  &__nav {
    position: relative;
    overflow: auto;
    align-self: stretch;
    align-items: center;
    flex-wrap: nowrap;
    list-style-type: none;
    width: max-content;
    display: flex;
    flex-direction: column;
    margin: 0;
    display: flex;
    gap: 10px;
    border-radius: 6px;
    max-height: 50%;
    min-height: 250px;
    overflow: auto;

    &-shadow {
      position: relative;
      max-height: 50%;
      min-height: 250px;
      flex: 0;

      &:after {
        content: '';
        width: 100%;
        height: 25%;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 100;
        transition: all 0.2s ease-in-out;
        pointer-events: none;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 100%
        );
      }

      &:before {
        content: '';
        width: 100%;
        height: 25%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
        transition: all 0.2s ease-in-out;
        pointer-events: none;
        background: linear-gradient(
          360deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 100%
        );
      }

      &.top:before {
        opacity: 0;
      }

      &.bottom:after {
        opacity: 0;
      }
    }

    &::-webkit-scrollbar {
      width: 0px;
    }

    &-wrapper {
      width: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
    }

    &-title {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.02em;
      color: #ffffff;
    }
  }

  &__tab {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 8px;
    width: 40px;
    height: 40px;
    min-height: 40px;
    background: transparent;
    transition: all 0.2s ease-in-out;
    text-align: center;
    color: #64686e;
    cursor: pointer;
    border-radius: 8px;
    border: 1px solid #7f97aa;
    font-size: 16px;
    font-weight: 700;
    line-height: 140%; /* 22.4px */
    letter-spacing: 0.48px;
    background: linear-gradient(
      107deg,
      #f6f8fd 36.98%,
      #e1e5f0 49.48%,
      #f6f8fd 61.46%
    );
    animation: 3s shine linear infinite;
    background-size: 200% 100%;

    &.is-active {
      background: #3e9eea;
      border-color: #3e9eea;

      color: #ffffff;
    }

    &.is-disabled {
      color: #364e65;
      background: transparent;
    }
  }

  &--vertical {
    flex-direction: row;

    .ui-tabs__nav-wrapper {
      flex-direction: column;
      flex-shrink: 0;
      align-items: center;
    }

    .ui-tabs__nav {
      flex-direction: column;
    }
  }
  &__panel {
    display: flex;
    align-items: center;
  }
}
@keyframes shine {
  to {
    background-position-x: -200%;
  }
}

ul {
  padding-inline-start: 0px;
}
</style>
